import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Store/store";
import App from "./App";
import axios from 'axios';
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { endSession, isSessionEnded, showSessionExpiredMessage } from "./Common/SessionManager";
import { API_DOMAIN } from "./Common/CommonVariables";

const holdUntilReload = () => new Promise(() => {});

axios.interceptors.request.use(function (config) {
  const token = store.getState();

  if (token.isAuthenticated) {

    const decoded = jwtDecode(token.AccessToken);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      endSession();

      return holdUntilReload();
      // window.location.href = "/";
    }
    config.headers.Authorization = `Bearer ${token.AccessToken}`;
  }
  else
    config.headers.Authorization = null;

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error?.config?.url || "";
    const isOwnApiCall = requestUrl.startsWith(API_DOMAIN);
    const isLogoutCall = requestUrl.endsWith("User/Logout");
    const wasLoggedIn = store.getState().isAuthenticated || isSessionEnded();
    if (error?.response?.status === 401 && isOwnApiCall && !isLogoutCall && wasLoggedIn) {
      endSession();
      return holdUntilReload();
    }
    return Promise.reject(error);
  }
);

showSessionExpiredMessage();

const root = ReactDOM.createRoot(document.getElementById("root")); // Use createRoot
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>  {/* Newly added for disabling context menu*/}
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);